import CustomerCreateEditForm from './CustomerCreateEditForm';

export default CustomerCreateEditForm;
